<template>
    <div class="tabs">
      <div class="tab-item" @click="routerClick('/doctor_content')" :class="{active:$route.path==='/doctor_content'}">
        医生详情
      </div>
      <div class="tab-item" @click="routerClick('/chat')" :class="{active:$route.path==='/chat'}">
        线上复诊
      </div>
    </div>

</template>

<script>
    export default {
        name: "fuzhen_tabs",
      data(){
        return{

        }
      },
      props:[
        'paths',
        'name'
      ],
      created(){

      },
      mounted(){

      },
      methods:{
         routerClick(path){
          this.$router.push({
            path:path,
            query:{
              doctorid:this.paths,
              name:this.name
            }
          })
        }
      }
    }
</script>

<style scoped>
  .tabs{
    width: 100%;
    height: 2.4rem;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 1rem;
    font-size: 0.8rem;
    font-weight: 700;
    line-height: 2.4rem;
    z-index: 2003;
  }
  .tab-item{
    width: 4.4rem;
    height: 100%;
    text-align: center;
  }
  .tab-item.active{
    color: #1890FF;
    border-bottom: 0.15rem solid #1890FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/fuzhen_tabs/fuzhen_tabs.vue